/* eslint-disable no-undef */

const TAG = 'MIXPANEL';

function track(event, data = {}) {
  try {
    mixpanel.track(event, data);
  } catch (error) {
    console.log(TAG, event, error);
  }
}

function alias(email) {
  try {
    mixpanel.alias(email);
  } catch (error) {
    console.log(TAG, 'alias', error);
  }
}

function person(id, email) {
  try {
    mixpanel.people.set({
      user_id: id,
      email,
      $email: email,
    });
  } catch (error) {
    console.log(TAG, 'people.set', error);
  }
}

const MixPanel = {
  userSet(id, email) {
    person(id, email);
  },

  cartItemAdd(sku) {
    track('add_to_cart', {
      product: sku,
    });
  },

  orderPaymentAdd(type, price, currency, promoCode) {
    track('payment', {
      type,
      promocode: promoCode,
      price,
      currency,
    });
  },

  orderPaymentFailure(type, price, currency, message) {
    track('payment_failure', {
      type: type || 'No payment',
      price,
      currency,
      error_code: 400,
      error_message: message || 'No message',
    });
  },

  orderSend(price, currency, externalOrderId, shippingType, promoCode, shippingAddress, items) {
    track('order_confirmed', {
      order_id: externalOrderId,
      shipping_method: shippingType,
      promocode: promoCode,
      price,
      currency,
    });

    items.forEach(item => {
      track('purchase_item', {
        product_id: item.id,
        quantity: item.quantity,
        price: item.single,
        currency,
      });
    });

    try {
      mixpanel.people.track_charge(price, {
        currency,
      });
    } catch (error) {
      console.log('MIXPANEL', error);
    }

    try {
      mixpanel.people.set({
        name: shippingAddress.name,
      });
    } catch (error) {
      console.log('MIXPANEL', error);
    }
  },

  editorInit(sku) {
    track('start_order', {
      product_id: sku,
    });
  },

  editorChoosePhotos() {
    track('choose_photos');
  },

  editorUploadPhotos(numberOfPhotos) {
    track('upload_photos', {
      photo_count: numberOfPhotos,
    });
  },

  editorPreviewPrints() {
    track('preview_prints');
  },

  editorPreviewDone(numberOfPages) {
    track('preview_done', {
      page_count: numberOfPages,
    });
  },

  editorUpgradeProduct(sku) {
    track('add_to_cart', {
      upgraded_product: sku,
    });
  },

  checkoutInit() {
    track('checkout');
  },

  checkoutAmazonInit() {
    track('checkout_amazon');
  },

  signIn(id, email) {
    track('sign_in', { email });
    alias(email);
    person(id, email);
  },

  signUp(id, email) {
    track('sign_up', { email });
    alias(email);
    person(id, email);
  },

  signInWithAmazon(id, email) {
    track('sign_in_up_amazon', { email });
    alias(email);
    person(id, email);
  },

  signInWithFacebook(id, email) {
    track('sign_in_with_facebook', { email });
    alias(email);
    person(id, email);
  },
};

export default MixPanel;
